<template>
    <div class="my-numbers">
        <Title :title="getTranslatedText('saved numbers')" />
        <TabGame @game-default="handleInitGame" @select-game="selecteGames" />
        <Loading v-if="isLoading" />
        <EmptyComponent v-else-if="!$store.state.isLogin" :description="getTranslatedText('Please login to continue!')" />
        <EmptyComponent v-else-if="isObjEmpty(listPick)"
            :description="getTranslatedText('Empty picks and numbers')" />
        <template v-else>
            <div class="list-outcome" >
                <div class="list-pick">
                    <p class="pick-item" :class="{ 'active': pickSelected == item }" @click="selectPick(item)"
                        v-for="(item, index) in Object.keys(listPick)" :key="index">
                        {{ getTranslatedText('pick') }} {{ item }}
                    </p>
                </div>
                <div class="action-name">
                    <p>{{ getTranslatedText('remove') }}</p>
                    <p>{{ getTranslatedText('add to betslip') }}</p>
                </div>
            </div>
            <div class="results">
                <div class="results-item" v-for="(r, i) in savedNumbers" :key="i">
                    <div class="col-1">
                        <p class="item market-name">{{ r.marketName }}</p>
                    </div>
                    <div class="col-3">
                        <div class="item list-number">
                            <Number v-for="(n, i) in r.numbers" :key="i" :number="n.value" :bgColor="n.color" />
                        </div>
                    </div>
                    <div class="col-05 action-content">
                        <p class="action action--remove" @click="handleRemoveNumber(r)"><i
                                class="bi bi-x-circle-fill"></i>
                        </p>
                        <p class="action action--add" @click="handleAddTobetslips(r)"><i
                                class="bi bi-plus-circle-fill"></i>
                        </p>
                    </div>
                </div>
            </div>
        </template>

        <div class="my-numbers__action">
            <ButtonCommon text="Back Home" class="button__custom-1" @action="backToHome" />
        </div>
    </div>
</template>
<script>
import languageMixins from "@/mixins/language-mixins";
import utilsMixins from "@/mixins/function-utils";
import Title from "@/components/common/title/index.vue";
import ButtonCommon from "@/components/common/button";
import Number from "@/components/common/number";
import Loading from '@/components/common/loading/loading.vue'
import EmptyComponent from '@/components/common/empty';
import TabGame from "@/components/common/tab/tab-game.vue"

import MyNumberService from "@/services/my-numbers/index.service.ts"
import EventBus from '@/utils/EventBus';
import { getStateStore, findOutcomeByMarketOptionId } from "@/utils/utils"
import betslipApiMixin from "@/mixins/betslip-api-mixin";
import { notify, notifyApiError } from "@/utils/notify";

export default {
    mixins: [languageMixins, utilsMixins, betslipApiMixin],
    components: { Title, ButtonCommon, Loading, Number, EmptyComponent, TabGame },
    data() {
        return {
            isLoading: false,
            fetchingNumbers: false,
            numbersLoaded: false,
            listGames: [],
            numbersData: [],
            listPick: [],
            savedNumbers: [],
            gameSelected: {},
            pickSelected: null,
        }
    },
    computed: {
        drawDate() {
            return this.$store.getters.drawDate();
        },
    },
    created() {
        this.getListGame()
        this.fetchData();
        EventBus.on("reload-my-numbers", this.fetchData)
    },
    unmounted() {
        EventBus.off("reload-my-numbers", this.fetchData)
    },
    methods: {
        async fetchData() {
            if (!this.gameSelected?.slug || this.fetchingNumbers) {
                return;
            }
            this.fetchingNumbers = true;
            this.isLoading = true;
            try {
                let res = await MyNumberService.getMyNumbers();
                if (res.status == 'success') {
                    this.numbersData = res.result || {};
                    this.selecteGames(this.gameSelected);
                }
            } catch (error) {
                notifyApiError(error);
            } finally {
                this.fetchingNumbers = false;
                this.numbersLoaded = true;
                this.isLoading = false;
            }
        },

        handleInitGame(game) {
            if (!game) return;
            this.gameSelected = game;
            if (!this.numbersLoaded) {
                this.fetchData();
                return;
            }
            this.selecteGames(game);
        },

        getListGame() {
            this.listGames = this.$store.state.gameMarket || [];
            this.gameSelected = this.listGames[0] || {};
        },

        handleRenderNumber(data) {
            let savedNumbers = [];
            if (data) {
                data.forEach(element => {
                    let numbersSave = element.saved_numbers;
                    let results = numbersSave.map(n => {
                        let numbers = this.gameSelected?.balls;
                        return {
                            id: n.id,
                            numbers: this.filterAndSortNumbers(numbers, n.numbers[0]),
                            marketName: n.market_name,
                            marketOptionName: n.market_options_name,
                            marketOptionsId: n.market_options_id,
                            gameSlug: this.gameSelected.slug,
                        }
                    })
                    savedNumbers.push(...results)
                });
            }

            return savedNumbers;
        },

        selecteGames(game) {
            this.gameSelected = game;
            // render pick allow game
            this.listPick = this.numbersData[game.slug]
            if (this.listPick) {
                this.pickSelected = Object.keys(this.listPick)[0]
                this.savedNumbers = this.handleRenderNumber(this.listPick[this.pickSelected])
            } else {
                this.pickSelected = null;
                this.savedNumbers = [];
            }

        },

        selectPick(item) {
            this.pickSelected = item;
            // render ball allow to pick
            this.savedNumbers = this.handleRenderNumber(this.listPick[this.pickSelected])
        },

        async handleRemoveNumber(item) {
            this.isLoading = true;
            //this.handleUpdateDataOfBetslips()
            try {
                // call api to remove
                let res = await MyNumberService.removemyNumber(item.id)

                if (res.status == "success") {
                    this.reloadData();
                    this.handleUpdateDataOfBetslips(item.id)
                }
            } catch (error) {
                notifyApiError(error);
                this.isLoading = false;
            }
        },

        handleUpdateDataOfBetslips(numberId) {
            const updateBets = (bets, commitType) => {
                const index = bets?.findIndex(x => x.myNumberId === numberId);
                if (index > -1) {
                    bets[index].isSavedNumbers = false;
                    delete bets[index].myNumberId;
                    this.$store.commit(commitType, { key: this.$store.state.accountKey, value: bets });
                }
            };
            const accountKey = this.$store.state.accountKey;
            const { betslips } = getStateStore().stateBetslip;

            updateBets(betslips[accountKey], 'saveBetslips');

            // reset postion
            EventBus.emit('calculate-bottom-page')
        },

        async reloadData() {
            let res = await MyNumberService.getMyNumbers();
            if (res.status == 'success') {
                this.numbersData = res.result;
                let dataAllowGame = this.numbersData[this.gameSelected.slug]
                if (dataAllowGame && dataAllowGame[this.pickSelected]) {
                    this.listPick = dataAllowGame;
                    this.savedNumbers = this.handleRenderNumber(this.listPick[this.pickSelected])
                } else {
                    let currentIndex = Object.keys(this.listPick).indexOf(this.pickSelected);

                    let hasPrevious = currentIndex > 0;
                    let hasNext = currentIndex < Object.keys(this.listPick).length - 1;
                    let isOnlyElement = Object.keys(this.listPick).length === 1;

                    if (isOnlyElement) {
                        this.listPick = [];
                        this.pickSelected = null;
                        this.savedNumbers = [];
                    } else if (hasPrevious && hasNext) {
                        delete this.listPick[this.pickSelected];
                        this.pickSelected = Object.keys(this.listPick)[currentIndex - 1];
                        this.savedNumbers = this.handleRenderNumber(this.listPick[this.pickSelected]);
                    }
                    else if (hasPrevious) {
                        delete this.listPick[this.pickSelected];
                        this.pickSelected = Object.keys(this.listPick)[currentIndex - 1];
                        this.savedNumbers = this.handleRenderNumber(this.listPick[this.pickSelected]);
                    }
                    else if (hasNext) {
                        delete this.listPick[this.pickSelected];
                        this.pickSelected = Object.keys(this.listPick)[currentIndex + 1];
                        this.savedNumbers = this.handleRenderNumber(this.listPick[this.pickSelected]);
                    }
                }
            }
            this.isLoading = false;
        },

        async handleAddTobetslips(item) {
            if (!this.$store.getters.drawDate(item.gameSlug)) {
                const query = this.$route.query;
                this.$router.push({ path: "/", query });
                notify({
                    text: this.getTranslatedText('draw limit reached. feel free to return for more later!'),
                    type: "error",
                });
                return;
            }

            const outcome = findOutcomeByMarketOptionId(
                this.$store.state.gameMarket,
                item.gameSlug,
                item.marketOptionsId
            );

            if (!outcome) {
                notify({
                    text: this.getTranslatedText("outcome not found"),
                    type: "error",
                });
                return;
            }

            const payload = {
                bets: [{
                    wager: outcome.bet_default,
                    event_id: this.$store.getters.drawDate(item.gameSlug).eventId,
                    market_options_id: item.marketOptionsId,
                    combination: false,
                    numbers: [item.numbers.map(x => x.value)]
                }]
            };
            await this.submitToBetslip(payload, { outcome });
        },

        backToHome() {
            const query = this.$route.query;
            this.$router.push({ path: "/", query });
        }
    },

}
</script>
<style lang="scss">
@import "@/public/scss/my-numbers/index.scss";
</style>